import React, { useState, useEffect } from 'react';
import './App.css';
import DisplayView from './components/DisplayView';
import RemoteView from './components/RemoteView';

function App() {
  const [view, setView] = useState('display');

  useEffect(() => {
    // Basic routing logic
    const params = new URLSearchParams(window.location.search);
    const viewParam = params.get('view');
    if (viewParam === 'remote') {
      setView('remote');
    } else {
      setView('display');
    }
  }, []);

  return (
    <div className="App">
      {view === 'remote' ? <RemoteView /> : <DisplayView />}
    </div>
  );
}

export default App;
